import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from 'react'
import { ProjectProps } from '../../interfaces/main-interfaces'

const Project:React.FC<ProjectProps> = ({ title, stack, thumb }) => {
    const image = getImage(thumb)
    return (
        <div>
            <GatsbyImage image={image} alt="sd" />
            <h3>{ title }</h3>
            <p>{ stack }</p>
        </div>
    )
}

export default Project
